module.exports = __webpack_public_path__ + "img/link.9ea47c4.png";